// src/pages/OAuthSuccess.js
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const OAuthSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userId = params.get('userId');
    const username = params.get('username');

    if (userId && username) {
      localStorage.setItem('userId', userId);
      localStorage.setItem('username', username);
      // Redirect to home page (or your protected route)
      navigate('/');
    } else {
      // If parameters are missing, redirect to login
      navigate('/login');
    }
  }, [location, navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      Processing OAuth login...
    </div>
  );
};

export default OAuthSuccess;
